import { cn } from "@/lib/utils";
import { ADMIN_SETTINGS_SECTIONS, type AdminSettingsSection } from "./types";

export function AdminSettingsNav({
  activeSection,
  onSection,
}: {
  activeSection: AdminSettingsSection;
  onSection: (section: AdminSettingsSection) => void;
}) {
  return (
    <aside className="lg:sticky lg:top-4 lg:self-start">
      <nav
        aria-label="Sekcije admin postavki"
        className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-2 [scrollbar-width:none] lg:mx-0 lg:flex-col lg:gap-1 lg:overflow-visible lg:rounded-2xl lg:border lg:border-border/60 lg:bg-card/60 lg:p-2 lg:shadow-sm [&::-webkit-scrollbar]:hidden"
      >
        {ADMIN_SETTINGS_SECTIONS.map((item) => {
          const active = activeSection === item.key;
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onSection(item.key)}
              aria-current={active ? "page" : undefined}
              className={cn(
                "group relative flex min-w-fit items-center gap-3 rounded-xl px-2.5 py-2.5 text-left transition-colors lg:w-full",
                active
                  ? "bg-primary text-primary-foreground shadow-sm shadow-primary/25"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground",
              )}
            >
              {active && (
                <span
                  aria-hidden
                  className="absolute inset-y-2 left-0 hidden w-[3px] rounded-full bg-primary lg:block"
                />
              )}
              <span
                className={cn(
                  "grid size-8 shrink-0 place-items-center rounded-lg border transition-colors",
                  active
                    ? "border-primary-foreground/20 bg-primary-foreground/15 text-primary-foreground"
                    : "border-border/60 bg-background text-muted-foreground group-hover:text-primary",
                )}
              >
                <Icon className="size-4" weight={active ? "duotone" : "regular"} />
              </span>
              <span className="min-w-0">
                <span className="block whitespace-nowrap text-sm font-semibold">{item.label}</span>
                <span className={cn("hidden truncate text-[11px] lg:block", active ? "text-primary-foreground/75" : "text-muted-foreground")}>
                  {item.description}
                </span>
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
